import { UserAvailability } from 'dashboard/models/user';
import { ApiModel, ApiResource } from 'lib/interfaces/api';

export interface CaseAssignmentPolicyAttributes {
  name: string;
  status: 'active' | 'archived';
  'distribution-type': 'case_creator' | 'fewest_cases' | 'inquiry_creator' | 'round_robin';
  'assignment-order-by': 'created_at' | 'sla_expires_at';
  'max-capacity': number | null;
  'assignee-team-ids': string[];
  'assignee-user-ids': string[];
  'case-source-list': {
    'source-type': 'case_template' | 'case_queue';
    'source-ids': string[];
  };
  'allowed-user-availabilities': UserAvailability[];
  'unassign-user-availabilities': UserAvailability[];

  'created-at': string;
  'updated-at': string;
  'archived-at': string;
}

export const DISTRIBUTION_TYPE_LABELS: Record<
  CaseAssignmentPolicyAttributes['distribution-type'],
  string
> = {
  round_robin: 'Round robin',
  case_creator: 'Case creator',
  inquiry_creator: 'Inquiry creator',
  fewest_cases: 'Fewest cases',
};

export interface CaseAssignmentPolicyRelationships {}

export type CaseAssignmentPolicy = ApiResource<
  CaseAssignmentPolicyAttributes,
  CaseAssignmentPolicyRelationships,
  ApiModel.CaseAssignmentPolicy
>;
